'use strict';

import { Entity } from '../Entity';
import { Ind } from './Ind';

export class IndMarx extends Entity {
  protected id;

  protected user;

  protected ind;

  protected data = [];

  protected currentPlanFlag;

  protected futurePlanFlag;

  protected deceasedFlag;

  protected badMbiFlag;

  protected currentContractNumber;

  protected currentPlanName;

  protected currentEnrollmentDate;

  protected futureContractNumber;

  protected futureEnrollmentDate;

  protected futurePlanName;

  protected resolved;

  protected dateCreated;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.user = data.user;

    this.ind = data.ind;

    this.data = [] = data.data = [];

    this.currentPlanFlag = data.currentPlanFlag;

    this.futurePlanFlag = data.futurePlanFlag;

    this.deceasedFlag = data.deceasedFlag;

    this.badMbiFlag = data.badMbiFlag;

    this.currentContractNumber = data.currentContractNumber;

    this.currentPlanName = data.currentPlanName;

    this.futureContractNumber = data.futureContractNumber;

    this.futurePlanName = data.futurePlanName;

    this.resolved = data.resolved;

    this.currentEnrollmentDate = '';

    this.futureEnrollmentDate = '';

    if (data.currentEnrollmentDate && data.currentEnrollmentDate != '') {
      const currentEnrollmentDate = data.currentEnrollmentDate.date.split(' ')[0].split('-');
      this.currentEnrollmentDate =
        currentEnrollmentDate[1] + '/' + currentEnrollmentDate[2] + '/' + currentEnrollmentDate[0];
    }

    if (data.futureEnrollmentDate && data.futureEnrollmentDate != '') {
      const futureEnrollmentDate = data.futureEnrollmentDate.date.split(' ')[0].split('-');
      this.futureEnrollmentDate =
        futureEnrollmentDate[1] + '/' + futureEnrollmentDate[2] + '/' + futureEnrollmentDate[0];
    }

    if (data.dateCreated && data.dateCreated != '') {
      const dateCreated = data.dateCreated.date.split(' ')[0].split('-');
      this.dateCreated = dateCreated[1] + '/' + dateCreated[2] + '/' + dateCreated[0];
    }

    if (data.ind) {
      const ind = new Ind();
      ind.hydrate(data.ind);

      this.ind = ind;
    }
  }

  public getId() {
    return this.id;
  }

  public getUser() {
    return this.user;
  }

  public getInd() {
    return this.ind;
  }

  public getData() {
    return (this.data = []);
  }

  public isCurrentPlanFlag() {
    return this.currentPlanFlag;
  }

  public isFuturePlanFlag() {
    return this.futurePlanFlag;
  }

  public isDeceasedFlag() {
    return this.deceasedFlag;
  }

  public isBadMbiFlag() {
    return this.badMbiFlag;
  }

  public getCurrentContractNumber() {
    return this.currentContractNumber;
  }

  public getCurrentPlanName() {
    return this.currentPlanName;
  }

  public getCurrentEnrollmentDate() {
    return this.currentEnrollmentDate;
  }

  public getFutureContractNumber() {
    return this.futureContractNumber;
  }

  public getFutureEnrollmentDate() {
    return this.futureEnrollmentDate;
  }

  public getFuturePlanName() {
    return this.futurePlanName;
  }

  public getDateCreated() {
    return this.dateCreated;
  }

  public getResolved() {
    return this.resolved;
  }
}
